import { useMemo } from 'react';
import { TransitionRotateDirection } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { TransitionPropertyOptions } from './TransitionPropertyOptions';
import Icon from '@/components/atoms/Icon';

export const TransitionRotation = ({
  selectedValue,
  onChange,
  disabled
}: {
  selectedValue: TransitionRotateDirection | null;
  onChange: (value: TransitionRotateDirection) => void;
  disabled: boolean;
}) => {
  const options = useMemo(() => {
    return [
      { Icon: <Icon name="IconRotateClockwise2" size={20} />, value: TransitionRotateDirection.CLOCKWISE },
      { Icon: <Icon name="IconRotate2" size={20} />, value: TransitionRotateDirection.ANTI_CLOCKWISE }
    ];
  }, []);
  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-1 mt-2.5 select-none text-xs font-medium text-[#A5A9AD]">Direction</div>
      <TransitionPropertyOptions
        disabled={disabled}
        options={options}
        onClick={onChange as any}
        selectedValue={selectedValue}
      />
    </div>
  );
};
